// scan-settings.js - 스캔 모드 및 용지 설정 관리

const SCAN_MODE_KEY = 'scantodesk_scan_mode';
const PAPER_SIZE_KEY = 'scantodesk_paper_size';
const LAST_PROCESS_OPTION_KEY = 'scantodesk_last_process_option';
const EXEC_PROVIDER_KEY = 'scantodesk_exec_provider';

/**
 * 현재 스캔 모드 반환
 * @returns {'simple' | 'document'}
 */
export function getScanMode() {
  return localStorage.getItem(SCAN_MODE_KEY) || 'simple';
}

/**
 * 스캔 모드 저장
 * @param {'simple' | 'document'} mode
 */
export function setScanMode(mode) {
  localStorage.setItem(SCAN_MODE_KEY, mode);
}

/**
 * locale 기반 기본 용지 크기
 * @returns {'a4' | 'letter'}
 */
export function getDefaultPaperSize() {
  const lang = navigator.language || navigator.userLanguage || '';
  // 미국, 캐나다, 멕시코 등은 Letter
  const letterLocales = ['en-us', 'en-ca', 'es-mx', 'fr-ca'];
  return letterLocales.includes(lang.toLowerCase()) ? 'letter' : 'a4';
}

/**
 * 현재 용지 크기 반환
 * @returns {'a4' | 'letter'}
 */
export function getPaperSize() {
  return localStorage.getItem(PAPER_SIZE_KEY) || getDefaultPaperSize();
}

/**
 * 용지 크기 저장
 * @param {'a4' | 'letter'} size
 */
export function setPaperSize(size) {
  localStorage.setItem(PAPER_SIZE_KEY, size);
}

/**
 * 마지막 처리 옵션 반환 (기본값: grayscale)
 * @returns {'bw' | 'gray' | 'color'}
 */
export function getLastProcessOption() {
  return localStorage.getItem(LAST_PROCESS_OPTION_KEY) || 'gray';
}

/**
 * 마지막 처리 옵션 저장
 * @param {'bw' | 'gray' | 'color'} option
 */
export function setLastProcessOption(option) {
  localStorage.setItem(LAST_PROCESS_OPTION_KEY, option);
}

/**
 * ML 실행 프로바이더 반환
 * @returns {'auto' | 'wasm'}
 */
export function getExecutionProvider() {
  return localStorage.getItem(EXEC_PROVIDER_KEY) || 'auto';
}

/**
 * ML 실행 프로바이더 저장
 * @param {'auto' | 'wasm'} provider
 */
export function setExecutionProvider(provider) {
  localStorage.setItem(EXEC_PROVIDER_KEY, provider);
}
